module.exports = __webpack_public_path__ + "static/logo_big-3bdcfc1ef212746bb4b68321028c05a6.png";